import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import { dateFormat } from '../../../utils/commonFunctions';
import ArrowButton from '../../common/button-arrow';

import './styles.css';
import { getGameBackgroundUrl } from '../../../actions/games';

class ThankYouPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true
    };
  }

  hideModal = () => {
    this.setState({ show: false });
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getGameBackgroundUrl());
    dispatch({ type: 'LOCK_SCROLL' });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({ type: 'UNLOCK_SCROLL' });
  }

  render() {
    const { order, deliveryDate, onOrderAgain, onNewOrder, onDone, gameBackgroundUrl } = this.props;
    const { show } = this.state;

    return (
      <div className="modal-container thank-you">
        <Modal
          show={show}
          container={this}
          onHide={this.hideModal}
          size="lg"
          aria-labelledby="contained-modal-title" >
          <Modal.Header closeButton className="no-border">
            <Row>
              <Col lg={12}>
                <PageTitle>Thank you for your order</PageTitle>
              </Col>
            </Row>
          </Modal.Header>
          <Modal.Body>
            {order['game-link'] !== null && order['has-enough-products'] &&
              <Row className="row-spacer row-game-banner" style={{ backgroundImage: `url(${gameBackgroundUrl})` }}>
                <Col lg={8} className="p-spacer">
                  <br />
                  <span className="game-banner-title">CONGRATULATIONS ON QUALIFYING
                    FOR A GAME WITH
                    CHANCE TO WIN €{order['game-prize']} IN POINTS
                  </span><br />
                  <span className="game-banner-text">please click on the below link to access the game</span><br/><br />
                  <ArrowButton href={order['game-link']} target={'_blank'} className="game grey-btn game-banner-button" color="grey" ghost={false}>
                    Play the game
                  </ArrowButton>
                </Col>
              </Row>}
            <Row>
              <Col lg={12} className="p-spacer">
                Your order number: <strong>{order['order-number']}</strong>
              </Col>
            </Row>
            {deliveryDate && <Row>
              <Col lg={12} className="p-spacer">
                Delivery date: <strong className="your-reference">{dateFormat(deliveryDate)}</strong>
              </Col>
            </Row>}
            <Row className="row-spacer">
              <Col lg={12} className="p-spacer">
                Your reference: <strong className="your-reference">{order['your-reference']}</strong>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="no-border">
            <Row className="row-spacer">
              <Col lg={6} className="ta-center">
                <Button className="red-ghost-btn" onClick={onOrderAgain}>Order again</Button>
              </Col>
              <Col lg={6} className="ta-center">
                <Button className="red-ghost-btn" onClick={onNewOrder}>New order</Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="ta-center">
                <Button className="grey-ghost-btn" onClick={onDone}>return to home page</Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    gameBackgroundUrl: state.games.gameBackgroundUrl
  };
};

export default connect(mapStateToProps)(ThankYouPanel);



// WEBPACK FOOTER //
// ./src/components/new-order/thank-you/index.jsx